// FILE: src/components/Events.jsx
// Member-facing events page used at route: /events

import React from "react";
import EventsMember from "./EventsMember";
import { useAuth } from "../context/AuthContext";
import { Link } from "react-router-dom";

export default function Events() {
  const { role } = useAuth();

  return (
    <div className="p-4 space-y-4">
      {/* Optional small header */}
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold">Upcoming Events</h2>

        {/* If admin, show a shortcut to the manage screen */}
        {role === "admin" && (
          <Link
            to="/admin/events"
            className="text-xs px-3 py-1 rounded-full border border-indigo-200 text-indigo-700 bg-indigo-50 hover:bg-indigo-100"
          >
            Open Manage Events
          </Link>
        )}
      </div>

      {/* Always show the member view list with RSVP / Check-in */}
      <EventsMember />
    </div>
  );
}
